import {Injectable} from '@angular/core';
import {PaginatorService} from "@shared/api/services/paginator.service";
import {Department, DepartmentBasic} from "@shared/api/models/query/department.model";
import {GetService} from "@shared/api/services/get.service";

@Injectable({
    providedIn: 'root'
})
export class DepartmentsService extends GetService<DepartmentBasic, Department> {

    protected override get domainEntity() {
        return 'departments';
    };
}
